/* eslint-disable import/no-default-export */
import React from 'react';
import { MemberModel } from 'app/gamma/src/types/models';
import AnonymousHeader from './anonymous-header';
import { AuthenticatedHeader } from './authenticated-header';
import StaticHeader from './static-header';

interface Props {
  me: MemberModel | undefined;
  isLoggedIn: boolean;
  alwaysOpenBoardsMenu: boolean;
  brandingColor: string | undefined;
  isStatic?: boolean;
  staticHeaderColor?: string;
}

class Header extends React.Component<Props> {
  render() {
    const {
      me,
      isLoggedIn,
      alwaysOpenBoardsMenu,
      brandingColor,
      isStatic,
      staticHeaderColor,
    }: Props = this.props;

    if (isStatic) {
      return <StaticHeader isLoggedIn={isLoggedIn} color={staticHeaderColor} />;
    }

    if (isLoggedIn) {
      return (
        <AuthenticatedHeader
          member={me}
          alwaysOpenBoardsMenu={alwaysOpenBoardsMenu}
          brandingColor={brandingColor}
        />
      );
    } else {
      return <AnonymousHeader />;
    }
  }
}

export default Header;
